import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Divider, IconButton, Stack } from "@mui/material";
import {
    FacebookTwoTone,
    Instagram,
} from "@mui/icons-material";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import { useDomainConfig } from "../../utils/domainConfigProvider";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

function AppFooter() {
  const { domainConfig } = useDomainConfig();


    return (
        <>
            <Box
                component="footer"
                sx={{
                    backgroundColor: domainConfig?.footerBgColor ? domainConfig?.footerBgColor : '#004e32',
                    color: 'white',
                    py: 1,
                    position: 'fixed',
                    bottom: 0,
                    width: '100%',
                    maxHeight: { xs: '30vh', sm: 'none' },
                    overflowY: { xs: 'auto', sm: 'visible' },
                }}
            >
                <Typography
                    variant="body2"
                    align="center"
                >
                    {/* {domainConfig?.footerText ? domainConfig?.footerText : '© 2024 All rights reserved.'} */}
                </Typography>
                {/* <SocialIcons /> */}
                <Stack
                    spacing={{ xs: 0.5, sm: 0.5 }}
                    direction="column"
                    useFlexGap
                    sx={{ px: { xs: 1, sm: 2 }, py: 0.5 }}
                >
                    <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={{ xs: 1, sm: 2 }}
                        justifyContent="space-between"
                        alignItems={{ xs: "center", sm: "center" }}
                        sx={{ width: '100%' }}
                    >
                        {/* Left side - WhatsApp and policies in separate rows */}
                        <Stack
                            direction="column"
                            spacing={{ xs: 0.5, sm: 1 }}
                            alignItems={{ xs: "center", sm: "flex-start" }}
                            sx={{ width: { xs: '100%', sm: 'auto' } }}
                        >
                            {/* WhatsApp row */}
                            {domainConfig?.whatsappNumber && (
                                <Stack direction="row" spacing={0} alignItems="center">
                                    <IconButton
                                        size="small"
                                        component="a" 
                                        target="_blank"
                                        href={`https://wa.me/${domainConfig?.whatsappNumber}`}
                                    >
                                        <WhatsAppIcon sx={{ color: 'white' }} />
                                    </IconButton>
                                    <Typography sx={{ fontSize: 12, color: 'white' }}>
                                        {domainConfig?.whatsappNumber}
                                    </Typography>
                                </Stack>
                            )}
                            
                            {/* Policies row */}
                            <Stack
                                direction={{ xs: "column", sm: "row" }}
                                spacing={{ xs: 1, sm: 2 }}
                                divider={<Divider orientation={{ xs: "horizontal", sm: "vertical" }} flexItem />}
                                alignItems={{ xs: "center", sm: "flex-start" }}
                            >
                                {domainConfig?.privacyPolicy && (
                                    <Typography
                                        color="inherit"
                                        component="a"
                                        target="_blank"
                                        href={domainConfig.privacyPolicy}
                                        variant="caption"
                                        fontWeight={500}
                                    >
                                        Privacy Policy
                                    </Typography>
                                )}
                                {domainConfig?.termsAndConditions && (
                                    <Typography
                                        component="a"
                                        color="inherit"
                                        target="_blank"
                                        href={domainConfig.termsAndConditions}
                                        variant="caption"
                                        fontWeight={500}
                                    >
                                        Terms & Conditions
                                    </Typography>
                                )}
                                {domainConfig?.returnPolicy && (
                                    <Typography
                                        component="a"
                                        color="inherit"
                                        target="_blank"
                                        href={domainConfig.returnPolicy}
                                        variant="caption"
                                        fontWeight={500}
                                    >
                                        Returns & Exchange
                                    </Typography>
                                )}
                            </Stack>
                        </Stack>

                        {/* Right side social icons and Prozo text */}
                        <Stack
                            direction="column"
                            alignItems="center"
                            spacing={{ xs: 0.5, sm: 1 }}
                            sx={{ width: { xs: '100%', sm: 'auto' } }}
                        >
                            <Stack
                                direction="row"
                                spacing={2}
                                justifyContent={{ xs: 'center', sm: 'flex-end' }}
                                sx={{ width: '100%' }}
                            >
                                {domainConfig?.whatsappNumber && (
                                    <IconButton
                                        size="small"
                                        component="a"
                                        target="_blank"
                                        href={`https://wa.me/${domainConfig?.whatsappNumber}`}
                                    >
                                        <WhatsAppIcon sx={{ color: 'white' }} />
                                    </IconButton>
                                )}
                                {domainConfig !== null && domainConfig.fbUrl && (
                                    <IconButton
                                        size="small"
                                        component="a"
                                        target="_blank"
                                        href={domainConfig?.fbUrl}
                                    >
                                        <FacebookTwoTone sx={{ color: 'white' }} />
                                    </IconButton>
                                )}

                                {domainConfig !== null && domainConfig.instaUrl && (
                                    <IconButton
                                        size="small"
                                        component="a"
                                        target="_blank"
                                        href={domainConfig?.instaUrl}
                                    >
                                        <Instagram sx={{ color: 'white' }} />
                                    </IconButton>
                                )}

                                {domainConfig !== null && domainConfig.twitterUrl && (
                                    <IconButton
                                        size="small"
                                        component="a"
                                        target="_blank"
                                        href={domainConfig?.twitterUrl}
                                    >
                                        <XIcon sx={{ color: 'white' }} fontSize="small" />
                                    </IconButton>
                                )}

                                {domainConfig !== null && domainConfig.linkedinUrl && (
                                    <IconButton
                                        size="small"
                                        component="a"
                                        target="_blank"
                                        href={domainConfig?.linkedinUrl}
                                    >
                                        <LinkedInIcon sx={{ color: 'white' }} />
                                    </IconButton>
                                )}
                            </Stack>
                            <Typography
                                variant="caption"
                                fontWeight={500}
                                sx={{
                                    fontSize: 12,
                                    color: '#b4b4b4',
                                    textAlign: 'center'
                                }}
                            >
                                Powered By &nbsp;<img
                                    src="/images/prozo-logo2.svg"
                                    alt="Prozo"
                                    onClick={() => { window.open('https://www.prozo.com/', '_blank') }}
                                    style={{
                                        width: '60px',
                                        height: '40px',
                                        verticalAlign: 'middle',
                                        cursor: 'pointer'
                                    }}
                                />
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
            </Box>
        </>
    );
}

export default AppFooter; 